import { Space } from '@procurify/ui'

import { type ApplicationStatus, type User } from '@webapp/models'
import { GlobalSearchTrigger } from '@webapp/platform/global-command'
import { TrialModeIndicator } from '../TrialModeIndicator'
import { AppHeaderDomainSwitch } from './components/AppHeaderDomainSwitch'
import { AppHeaderLogo } from './components/AppHeaderLogo'
import { AppHeaderUser } from './components/AppHeaderUser'
import { AppHeaderUserImpersonationSwitch } from './components/AppHeaderUserImpersonationSwitch'
import { ConnectedAppHeaderInbox } from './components/ConnectedAppHeaderInbox'
import { QuickRequestButton } from './components/QuickRequestButton'
import { AppHeaderStyled } from './styles/AppHeaderStyled'

export interface IAppHeaderProps {
  user: User
  showUserImpersonationSwitch?: boolean
  showDomainSwitch?: boolean
  showGlobalSearchTrigger?: boolean
  applicationStatus: ApplicationStatus
}

export const AppHeader = ({
  user,
  showUserImpersonationSwitch,
  showDomainSwitch,
  showGlobalSearchTrigger,
  applicationStatus,
}: IAppHeaderProps) => {
  const { lock_mode, trial_mode } = applicationStatus
  const showTrialIndicatorButton = lock_mode || trial_mode

  return (
    <AppHeaderStyled>
      <Space direction='horizontal' align='center' justify='space-between'>
        <AppHeaderLogo />

        {showGlobalSearchTrigger && <GlobalSearchTrigger />}

        <Space direction='horizontal' align='center' size='large' justify='end'>
          <QuickRequestButton />

          {showTrialIndicatorButton && (
            <TrialModeIndicator applicationStatus={applicationStatus} />
          )}

          {(showUserImpersonationSwitch || showDomainSwitch) && (
            <Space direction='horizontal' align='center' size='small'>
              {showUserImpersonationSwitch && (
                <AppHeaderUserImpersonationSwitch />
              )}

              {showDomainSwitch && <AppHeaderDomainSwitch />}
            </Space>
          )}

          <Space direction='horizontal' align='center' size='large'>
            <ConnectedAppHeaderInbox />
            <AppHeaderUser user={user} />
          </Space>
        </Space>
      </Space>
    </AppHeaderStyled>
  )
}

AppHeader.displayName = 'AppHeader'
